import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomizeTableColumnsComponent } from "../../../customize-table-columns/customize-table-columns.component";
import { TableSearchComponent } from "../../../table-search/table-search.component";
import { DownloadType } from "../../../../constant/common-table";
import { FilterItem, TableColumn } from "../../../../models/common-table";

@Component({
  selector: "app-common-table-toolbar",
  standalone: true,
  imports: [CommonModule, CustomizeTableColumnsComponent, TableSearchComponent],
  templateUrl: "./common-table-toolbar.component.html",
})
export class CommonTableToolbarComponent {
  @Input() showColumnSelectAccordion = true;
  @Input() showFilterAccordion = true;
  @Input() columns: TableColumn[] = [];
  @Input() loading = false;
  @Input() selectableRows = false;
  @Input() disableDownload = false;
  @Input() dynamicPagination = false;
  @Input() rowsLength = 0;
  @Input() lowerCaseInput = true;
  @Input() filterItems: FilterItem[] = [];
  @Input() tableName = "";

  @Output() columnSelectionChanged = new EventEmitter<Partial<TableColumn>[]>();
  @Output() filtersChanged = new EventEmitter<FilterItem[]>();
  @Output() downloadEvent = new EventEmitter<DownloadType>();

  public onColumnSelectionChanged(updatedColumns: Partial<TableColumn>[]): void {
    this.columnSelectionChanged.emit(updatedColumns);
  }

  public onFiltersChanged(updatedFilters: FilterItem[]): void {
    this.filtersChanged.emit(updatedFilters);
  }

  public onDownload(downloadType: DownloadType): void {
    this.downloadEvent.emit(downloadType);
  }
}
